// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');

const {
    BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_ASSOCIATED_ACCOUNTS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_ASSOCIATED_ACCOUNTS_SUCCESS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_INTERVENERS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_INTERVENERS_SUCCESS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_ADD_INTERVENER,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_REMOVE_INTERVENER,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_RESET_INTERVENERS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_CHANGE_ASSOCIATED_ACCOUNT,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_CHANGE_ACCEPT_MANIFEST,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_UPDATE_INTERVENERS_API_SUCCESS,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_SET_VISIBLE_STEP,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_VALIDATE_STEP,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_FINISH,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_RESET
} = require('constants/actionTypes');

const fetchAssociatedAccountsSuccess = (response) => {
    return {
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_ASSOCIATED_ACCOUNTS_SUCCESS,
        payload: { response }
    };
};

const fetchAssociatedAccounts = () => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_ASSOCIATED_ACCOUNTS,
        payload: {}
    });

    const url = apiURLBuilder.getURL('contratacionDerivados');

    APIGet(dispatch, url, {}).then(
        response => dispatch(fetchAssociatedAccountsSuccess(response))
    );
};

const fetchIntervenersSucces = (response, contractNumber) => {
    return {
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_INTERVENERS_SUCCESS,
        payload: { response, contractNumber }
    };
};

const fetchInterveners = (contractNumber, product, balance) => (dispatch, getState) => {
    // Do not fetch interveners twice
    if (getState().brokerHireDerivativesAccount.getIn(['interveners', contractNumber])) {
        return;
    }

    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_FETCH_INTERVENERS,
        payload: {}
    });

    const url = apiURLBuilder.getURL('contratacionDerivadosCapt');

    const requestData = {
        numeroContrato: contractNumber,
        producto: product,
        saldo: balance
    };

    APIGet(dispatch, url, { query: requestData }).then(
        response => dispatch(fetchIntervenersSucces(response, contractNumber))
    );
};

const addIntervener = () => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_ADD_INTERVENER,
        payload: {}
    });
};

const removeIntervener = (index) => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_REMOVE_INTERVENER,
        payload: { index }
    });
};

const resetInterveners = () => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_RESET_INTERVENERS,
        payload: {}
    });
};

const selectAssociatedAccount = (value) => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_CHANGE_ASSOCIATED_ACCOUNT,
        payload: { value }
    });
};

const changeAcceptManifest = () => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_CHANGE_ACCEPT_MANIFEST,
        payload: {}
    });
};

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_SET_VISIBLE_STEP,
        payload: { step }
    });
};

const performOperationSuccess = (response) => {
    return {
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_FINISH,
        payload: { response }
    };
};

const performOperation = (dispatch, getState, token) => {
    const immBrokerHireDerivativesAccount = getState().brokerHireDerivativesAccount;
    const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
        ['steps', FIRST_STEP, 'selectedAssociatedContract']
    );
    const immSelectedAssociatedAccount = immBrokerHireDerivativesAccount.getIn(
        ['contracts', selectedAssociatedContract]
    );

    const url = apiURLBuilder.getURL('contratacionDerivadosConfirmacion');

    const requestData = {
        campana: '0016', // --> confirmar
        canalComer: 'KFC', // --> opcional -> confirmar
        canalOper: 'KFC', // --> opcional -> confirmar
        codCanal: 'EML', // || CONFIRMADO [EML, SMS]
        codFormato: '02', // --> confirmar
        codMarca: '0073', // --> opcional -> confirmar
        //codMoneda: 'EUR', // --> opcional -> confirmar
        //numPersSel: immBrokerHireDerivativesAccount.getIn(['steps', FIRST_STEP, 'interveners']).first().get('personNumber'), // --> que persona debe ser?
        //numSeq: immBrokerHireDerivativesAccount.getIn(['listaMailsSinFormato', 'mail', 'numSeq']) ||
        //        immBrokerHireDerivativesAccount.getIn(['listaMoviles', 'movil', 'numSeq']),
        gestor: '000213', // --> confirmar
        numSeq: 3, // --> confirmar
        referencia: '0000001', // --> confirmar
        subtipo: '804', // --> confirmar
        tipo: '300', // --> confirmar
        tipoDispositivo: '02', // --> confimar
        //tipoPersSel: 'F', // --> confirmar
        contratoSel: {
            numerodecontrato: immSelectedAssociatedAccount.get('contractNumber'),
            producto: immSelectedAssociatedAccount.get('product')
        },
        dataToken: token
    };

    APIPost(dispatch, url, { query: requestData }).then(
        (response) => dispatch(performOperationSuccess(response))
    );
};

const validateSignature = (dispatch, getState) => {
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        (dispatch, getState, token) => performOperation(dispatch, getState, token)
    );
};


const finish = () => (dispatch, getState) => {
    validateSignature(dispatch, getState);
};

const reset = () => (dispatch) => dispatch({
    type: BROKER_HIRE_DERIVATIVES_ACCOUNT_RESET
});

const updateIntervenersAPISuccess = (response) => {
    return {
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_UPDATE_INTERVENERS_API_SUCCESS,
        payload: { response }
    };
}

const updateIntervenersAPI = (dispatch, getState) => {
    const immBrokerHireDerivativesAccount = getState().brokerHireDerivativesAccount;
    const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
        ['steps', FIRST_STEP, 'selectedAssociatedContract']
    );
    const immSelectedAssociatedAccount = immBrokerHireDerivativesAccount.getIn(
        ['contracts', selectedAssociatedContract]
    );
    const immFirstStepInterveners = immBrokerHireDerivativesAccount.getIn(['steps', FIRST_STEP, 'interveners']);

    const url = apiURLBuilder.getURL('contratacionDerivadosBdp');

    const requestData = {
        contrato: {
            numerodecontrato: immSelectedAssociatedAccount.get('contractNumber'),
            producto: immSelectedAssociatedAccount.get('product')
        },
        //entidad: "string",
        icollIntervinientes: {
            persona: immFirstStepInterveners.map(immIntervener => {
                return {
                    numeroPersona: immIntervener.get('personNumber'),
                    tipoPersona: immIntervener.get('personType')
                }
            })
        },
        reposTipoConsulta: '1'
    };

    APIPost(dispatch, url, { query: requestData }).then((response) => {
        setVisibleStep(SECOND_STEP + 1)(dispatch);
        dispatch(updateIntervenersAPISuccess(response));
    });
};

const validateStep = (step) => (dispatch, getState) => {
    dispatch({
        type: BROKER_HIRE_DERIVATIVES_ACCOUNT_VALIDATE_STEP,
        payload: { step }
    });

    const immBrokerHireDerivativesAccount = getState().brokerHireDerivativesAccount;
    const currentStepValid = immBrokerHireDerivativesAccount.getIn(['steps', step - 1, 'valid']);
    const lastStep = immBrokerHireDerivativesAccount.get('steps').size === step;

    if (currentStepValid) {
        if (lastStep) {
            finish()(dispatch, getState);
        } else if (FIRST_STEP === step - 1) {
            updateIntervenersAPI(dispatch, getState);
        } else {
            setVisibleStep(step + 1)(dispatch);
        }
    }
};

module.exports = {
    fetchAssociatedAccounts,
    fetchInterveners,
    addIntervener,
    removeIntervener,
    resetInterveners,
    selectAssociatedAccount,
    changeAcceptManifest,
    validateStep,
    setVisibleStep,
    finish,
    reset
};
